import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root'
})
export class ArticleHtmlTransformer {

  constructor() {}

  getStringInsideTags(str: string, tag: string, tagEnd?: string): string {
    const tagIdx = str.indexOf(tag)
    if (tagIdx === -1) {
      return ''
    }
    const tagEndIdx = tagEnd ? str.indexOf(tagEnd) : undefined
    return str.slice(tagIdx + tag.length, tagEndIdx)
  }


  rmQuotes(str: string): string {
    const quoteStart = '“'
    const quoteEnd = '”'
    const qsIdx = str.indexOf(quoteStart)
    const qeIdx = str.indexOf(quoteEnd)
    if (qsIdx !== -1) {
      return str.slice(qsIdx + quoteStart.length, qeIdx !== -1 ? qeIdx : undefined)
    }
    return str
  }

  rmSpace(str: string): string {
    const space = '&nbsp;'
    return str.split(space).join('').trim()
  }
  rmRowRow(str: string): string {
    const rowrow = '--'
    return str.split(rowrow).join('').trim()
  }

  replaceOnBody(body, str1, str2) {
    return body.replace(str1, str2)
  }

  placeSpanInFront(str) {
    const quoteStart = '“'
    const classH = 'bigOrangeQuote'
    const res =  `<span class="${classH}">${quoteStart}</span>`
    const i = str.indexOf('<b')
    return str.slice(0, i) + res + str.slice(i)
  }

  placeBClass(str: string): string {
    const classH = 'boldQuoteTitle'
    return ` class="${classH}" ` + str
  }
  placeDivClass(str: string): string {
    const classH = 'quoteAuthor'
    return ` class="${classH}" ` + str
  }
  placeSpanClass(str: string): string {
    const classH = 'quoteAuthorSpan'
    return ` class="${classH}" ` + str
  }

}
